module.exports = " <h6>Your browser is out of date!</h6> <p>Update your browser to view this website correctly. <a id=btnUpdateBrowser href=http://outdatedbrowser.com/ >Update my browser now </a></p> <p class=last><a href=# id=btnCloseUpdateBrowser title=Close>&times;</a></p> ";


//////////////////
// WEBPACK FOOTER
// ./outdated-browser/lang/en.html
// module id = 819
// module chunks = 2